import React, { FC } from 'react'
import { StyledError } from './APIError.styles'
import { useTranslation } from 'react-i18next'
import { CombinedGraphQLErrors } from '@apollo/client'

interface ErrorProps {
  error: Error
}

export const APIError: FC<ErrorProps> = ({ error }) => {
  const { t } = useTranslation()

  if (CombinedGraphQLErrors.is(error)) {
    return (
      <>
        {error.errors.map(({ message }, index) => (
          <StyledError key={`gqle_${index}`}>{message}</StyledError>
        ))}
      </>
    )
  } else if (error) {
    return <StyledError>{error.message}</StyledError>
  }

  return <StyledError>{t('pages.login.errors.generic')}</StyledError>
}
